module.exports = __webpack_public_path__ + "assets/img/default-avatar.f13e9e0b.png";